import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import type {
  TComboboxGroupElement,
  TComboboxGroupProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { cn } from "@/ui/lib/utils";

export const ComboboxGroup = forwardRef<TComboboxGroupElement, TComboboxGroupProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive.Group
      data-component="ComboboxGroup"
      ref={ref}
      className={cn(
        "overflow-hidden p-1 text-foreground-default",
        "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-foreground-muted",
        className,
      )}
      {...props}
    />
  ),
);

ComboboxGroup.displayName = CommandPrimitive.Group.displayName;
